export default __webpack_public_path__ + "static/media/award1.dac1fb8a.svg";